import { QueryParams, qsSerialize } from '@websolutespa/bom-core';
import { ApiRequestOptions } from '@websolutespa/bom-mixer-store';
import { useApiFetch } from '../useApi/useApi';
import { useLayout } from '../useLayout/useLayout';
import { localCollectionDelete, localCollectionGet, localCollectionPatch, localCollectionPost, localCollectionPut } from './local.collection';

type CollectionApi = {
  get: <T = unknown>(pathname: string, params?: QueryParams, options?: ApiRequestOptions) => Promise<T>;
  post: <T = unknown>(pathname: string, payload?: unknown, options?: ApiRequestOptions) => Promise<T>;
  put: <T = unknown>(pathname: string, payload?: unknown, options?: ApiRequestOptions) => Promise<T>;
  patch: <T = unknown>(pathname: string, payload?: unknown, options?: ApiRequestOptions) => Promise<T>;
  delete: <T = unknown>(pathname: string, options?: ApiRequestOptions) => Promise<T>;
};

export function useCollectionApi(): CollectionApi {
  const layout = useLayout();
  return {
    get: async <T = unknown>(pathname: string, params: QueryParams = {}, options: ApiRequestOptions = {}) => {
      params.locale = params.locale || layout.locale;
      params.market = params.market || layout.market;
      const qs = qsSerialize(params);
      return localCollectionGet<T>(pathname + (qs ? '?' + qs : ''), options);
    },
    post: async <T = unknown>(pathname: string, payload?: unknown, options: ApiRequestOptions = {}) => {
      return localCollectionPost<T>(pathname, payload, options, layout);
    },
    put: async <T = unknown>(pathname: string, payload?: unknown, options: ApiRequestOptions = {}) => {
      return localCollectionPut<T>(pathname, payload, options, layout);
    },
    patch: async <T = unknown>(pathname: string, payload?: unknown, options: ApiRequestOptions = {}) => {
      return localCollectionPatch<T>(pathname, payload, options, layout);
    },
    delete: async <T = unknown>(pathname: string, options: ApiRequestOptions = {}) => {
      return localCollectionDelete<T>(pathname, options, layout);
    },
  };
}

/*
export function useCollectionApiFetch<T = unknown>(pathname: string, options: ApiRequestOptions = {}) {
  const layout = useLayout();
  // const layout = { locale: '', market: '' };
  return useHttpFetch<T>(pathname, options, localApiFetch, layout);
}
*/

export function useCollectionApiGet<T = unknown>(pathname: string, params?: QueryParams, options: ApiRequestOptions = {}) {
  const api = useApiFetch<T>(pathname, { ...options, method: 'GET' });
  return api;
}

export function useCollectionApiPost<T = unknown>(pathname: string, payload: unknown, options: ApiRequestOptions = {}) {
  return useApiFetch<T>(pathname, { ...options, method: 'POST', body: payload ? JSON.stringify(payload) : undefined });
}

export function useCollectionApiPut<T = unknown>(pathname: string, payload: unknown, options: ApiRequestOptions = {}) {
  return useApiFetch<T>(pathname, { ...options, method: 'PUT', body: payload ? JSON.stringify(payload) : undefined });
}

export function useCollectionApiPatch<T = unknown>(pathname: string, payload: unknown, options: ApiRequestOptions = {}) {
  return useApiFetch<T>(pathname, { ...options, method: 'PATCH', body: payload ? JSON.stringify(payload) : undefined });
}

export function useCollectionApiDelete<T = unknown>(pathname: string, options: ApiRequestOptions = {}) {
  return useApiFetch<T>(pathname, { ...options, method: 'DELETE' });
}
